import type { AdditionalService } from "@/types/generated/ExperienceMasterDataApi";

/**
 * Filters out archived additional services (unless currently selected)
 * and sorts the remaining items by visualization_order ascending.
 * Items with undefined visualization_order are placed last.
 * Uses a stable sort to preserve relative order for equal values.
 */
export function filterAndSortAdditionalServices(
  services: AdditionalService[],
  selectedCode: string
): AdditionalService[] {
  const filtered = services.filter((service) => !service.archived || service.code === selectedCode);

  return filtered.toSorted((a, b) => {
    const orderA = a.visualization_order;
    const orderB = b.visualization_order;

    if (orderA === undefined && orderB === undefined) return 0;
    if (orderA === undefined) return 1;
    if (orderB === undefined) return -1;
    return orderA - orderB;
  });
}
